<template>
  <span :class="className">{{ status }}</span>
</template>

<script>

const VERIFICATION_STATUSES = [
  {
    id: 'RED',
  },
  {
    id: 'GREEN',
  },
]

export default {
  name: 'verification-status',
  props: {
    status: { type: String, default: VERIFICATION_STATUSES[0].id },
  },
  computed: {
    className () {
      return `verification-status-${this.status}`
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~@scss/variables';

  .verification-status-GREEN {
    color: $col-sumsub-review-answer-green;
    font-weight: 600;
  }

  .verification-status-RED {
    color: $col-sumsub-review-answer-red;
    font-weight: 600;
  }
</style>
